import { normalize } from 'normalizr';

import api from 'helpers/api';
import * as schemas from '../schemas';

export function fetchRegion(id) {
  return api.backend
    .get(`regions/${id}`)
    .then(response => normalize(response.data.region, schemas.region));
}



// WEBPACK FOOTER //
// ./src/api/regions.js